// tslint:disable:no-invalid-this only-arrow-functions
import { HttpHeaders } from '@angular/common/http';
import { Inject, Injector } from '@angular/core';
// import { ACLService } from '@delon/acl';
import { throwError, Observable } from 'rxjs';

import { _HttpClient } from './http.client';

export abstract class BaseApi {
  constructor(@Inject(Injector) protected injector: Injector) { }
}

export interface HttpOptions {
  /** ACLéç½®ï¼è¥å¯¼å¥ `@delon/acl` æ¶èªå¨ææï¼ç­åäº `ACLService.can(roleOrAbility: ACLCanType)` åæ°å¼ */
  acl?: any;
  observe?: 'body' | 'events' | 'response';
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  reportProgress?: boolean;
  withCredentials?: boolean;
}

interface ParamType {
  key: string;
  index: number;
  [key: string]: any;
  [key: number]: any;
}

const paramKey = `__api_params`;

function setParam(target: any, key = paramKey) {
  let params = target[key];
  if (typeof params === 'undefined') {
    params = target[key] = {};
  }
  return params;
}

/**
 * é»è®¤åºåURL
 * - ææèå´ï¼ç±»
 */
export function BaseUrl(url: string) {
  return function <TClass extends new (...args: any[]) => BaseApi>(target: TClass): TClass {
    const params = setParam(target.prototype);
    params.baseUrl = url;
    return target;
  };
}

/**
 * é»è®¤ `headers`
 * - ææèå´ï¼ç±»
 */
export function BaseHeaders(
  headers:
    | HttpHeaders
    | {
      [header: string]: string | string[];
    },
) {
  return function <TClass extends new (...args: any[]) => BaseApi>(target: TClass): TClass {
    const params = setParam(target.prototype);
    params.baseHeaders = headers;
    return target;
  };
}

function makeParam(paramName: string) {
  return function (key?: string) {
    return function (target: BaseApi, propertyKey: string, index: number) {
      const params = setParam(setParam(target), propertyKey);
      let tParams = params[paramName];
      if (typeof tParams === 'undefined') {
        tParams = params[paramName] = [];
      }
      tParams.push({
        key,
        index,
      });
    };
  };
}

/**
 * URLè·¯ç±åæ°
 * - ææèå´ï¼æ¹æ³åæ°
 */
export const Path = makeParam('path');

/**
 * URL åæ° `QueryString`
 * - ææèå´ï¼æ¹æ³åæ°
 */
export const Query = makeParam('query');

/**
 * åæ° `Body`
 * - ææèå´ï¼æ¹æ³åæ°
 */
export const Body = makeParam('body')();

/**
 * åæ° `headers`
 * - ææèå´ï¼æ¹æ³åæ°
 * - åå¹¶ `BaseHeaders`
 */
export const Headers = makeParam('headers');

/**
 * Request Payload
 * - Supported body (like`POST`, `PUT`) as a body data, equivalent to `@Body`
 * - Not supported body (like `GET`, `DELETE` etc) as a `QueryString`
 */
export const Payload = makeParam('payload')();

function getValidArgs(data: any, key: string, args: any[]): {} | undefined {
  if (!data[key] || !Array.isArray(data[key]) || data[key].length <= 0) {
    return undefined;
  }
  return args[data[key][0].index];
}

function genBody(data?: any, payload?: any): any {
  if (Array.isArray(data) || Array.isArray(payload)) {
    // tslint:disable-next-line:prefer-object-spread
    return Object.assign([], data, payload);
  }
  // tslint:disable-next-line:prefer-object-spread
  return Object.assign({}, data, payload);
}

function makeMethod(method: string) {
  return function (url: string = '', options?: HttpOptions) {
    return (_target: BaseApi, targetKey?: string, descriptor?: PropertyDescriptor) => {
      descriptor!.value = function (...args: any[]): Observable<any> {
        options = options || {};

        const http = this.injector.get(_HttpClient, null) as _HttpClient;
        if (http == null) {
          throw new TypeError(`Not found '_HttpClient', You can import 'AlainThemeModule' && 'HttpClientModule' in your root module.`);
        }

        const baseData = setParam(this);
        const data = setParam(baseData, targetKey);

        let requestUrl = url || '';
        requestUrl = [baseData.baseUrl || '', requestUrl.startsWith('/') ? requestUrl.substr(1) : requestUrl].join('/');
        // fix last split
        if (requestUrl.length > 1 && requestUrl.endsWith('/')) {
          requestUrl = requestUrl.substr(0, requestUrl.length - 1);
        }

        // if (options.acl) {
        //   const aclSrv: ACLService = this.injector.get(ACLService, null);
        //   if (aclSrv && !aclSrv.can(options.acl)) {
        //     return throwError({
        //       url: requestUrl,
        //       status: 401,
        //       statusText: `From Http Decorator`,
        //     });
        //   }
        //   delete options.acl;
        // }

        requestUrl = requestUrl.replace(/::/g, '^^');
        ((data.path as ParamType[]) || [])
          .filter(w => typeof args[w.index] !== 'undefined')
          .forEach((i: ParamType) => {
            requestUrl = requestUrl.replace(new RegExp(`:${i.key}`, 'g'), encodeURIComponent(args[i.index]));
          });
        requestUrl = requestUrl.replace(/\^\^/g, `:`);

        const params = (data.query || []).reduce((p: {}, i: ParamType) => {
          p[i.key] = args[i.index];
          return p;
        }, {});

        const headers = (data.headers || []).reduce((p: {}, i: ParamType) => {
          p[i.key] = args[i.index];
          return p;
        }, {});

        const payload = getValidArgs(data, 'payload', args);
        const supportedBody = method === 'POST' || method === 'PUT';

        return http.request(method, requestUrl, {
          body: supportedBody ? genBody(getValidArgs(data, 'body', args), payload) : null,
          params: !supportedBody ? { ...params, ...payload } : params,
          headers: { ...baseData.baseHeaders, ...headers },
          ...options,
        });
      };

      return descriptor;
    };
  };
}

/**
 * `OPTIONS` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const OPTIONS = makeMethod('OPTIONS');

/**
 * `GET` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const GET = makeMethod('GET');

/**
 * `POST` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const POST = makeMethod('POST');

/**
 * `DELETE` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const DELETE = makeMethod('DELETE');

/**
 * `PUT` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const PUT = makeMethod('PUT');

/**
 * `HEAD` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const HEAD = makeMethod('HEAD');

/**
 * `PATCH` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const PATCH = makeMethod('PATCH');

/**
 * `JSONP` è¯·æ±
 * - ææèå´ï¼æ¹æ³
 */
export const JSONP = makeMethod('JSONP');
